import * as React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@gasbuddy/react-components';
import { LocaleButton } from '@gasbuddy/react-consumer-components';
import classnames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import styles from './Navbar.module.css';

const cx = classnames.bind(styles);

export default function Navbar({ children = null, onLocaleChange = null }) {
  const { t, i18n } = useTranslation('miscellaneous');

  return (
    <header className={cx('navbar')}>
      <Image
        src="https://images.gasbuddy.com/images/websites/gasbuddy/gb-logo-horizontal.png"
        alt={t('gasBuddyLogoAlt')}
        className={cx('logo')}
      />
      <div className={cx('navbarContent')}>
        {children}
        <LocaleButton
          currentLocale={i18n.language}
          onSubmit={onLocaleChange}
          size="sm"
          className={cx('localeButton')}
          titleText={t('localeSelectTitle')}
          cancelText={t('cancel')}
          submitText={t('submit')}
        />
      </div>
    </header>
  );
}

Navbar.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  onLocaleChange: PropTypes.func,
};
